import { ReactQueryDevtools as RQDevtools } from 'react-query/devtools'

const ReactQueryDevtools = () => {
  return <RQDevtools position="bottom-right" />
}

export default ReactQueryDevtools
